var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 152 143"}},[_c('polygon',{attrs:{"points":"0 0 0 142.638954 55.2661 142.638954 55.2661 51.3773912 127.99675 51.3773912 151.61625 0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }